import {
    Alert,
    Avatar,
    Box,
    Button,
    Chip,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    Drawer,
    FormControl,
    FormControlLabel,
    Grid,
    Radio,
    RadioGroup,
    Stack,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import {useFormik} from 'formik';
import {useFetch} from '../../hooks/useFetch';
import Close from '../../assets/closed.png';
import useHandleErrors from '../../hooks/useHandleErrors';
import LoadingContent from '../../components/LoadingContent';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {useAuth} from '../../context/AuthContext';
import {useEffect, useMemo, useState} from 'react';
import {format, isValid} from 'date-fns';
import {useApp} from '../../context/AppContext';
import FilterForm from '../../components/FilterForm';
import lodash from 'lodash';
import {AccountCircle} from '@mui/icons-material';
import FeedSearch from './compoments/FeedSearch';

export default () => {
    const {user} = useAuth();
    const [searchParams, setSearchParams] = useSearchParams();
    const [openFilter, setOpenFilter] = useState(false);
    const navigation = useNavigate();

    const {values, errors, handleChange, setValues, setFieldValue, handleSubmit, handleReset} =
        useFormik({
            initialValues: {
                raffle: '',
                visible_public: '',
                seller_name: '',
                topics: [],
                date: '',
                time: '',
                title: '',
            },
            onSubmit: async values => {
                if (Boolean(values.raffle)) {
                    values.raffle = values.raffle === 'false' ? false : true;
                }
                if (Boolean(values.visible_public)) {
                    values.visible_public = values.visible_public === 'false' ? false : true;
                }
                setOpenFilter(false);

                // Data e hora sao objetos Date vindos dos campos. O servidor
                // espera 'yyyy-MM-dd' e 'HH:mm'; mandar o ISO completo faz o
                // filtro de hora virar data invalida no backend.
                const filtros = lodash.omitBy(values, v => v === '' || v === null || v === undefined);
                filtros.date = isValid(values.date) ? format(values.date, 'yyyy-MM-dd') : undefined;
                filtros.time = isValid(values.time) ? format(values.time, 'HH:mm') : undefined;

                setSearchParams(lodash.omitBy(filtros, v => v === undefined));
            },
        });

    // useEffect(() => {
    //     if (Boolean(searchParams)) {
    //         let toFields = Object.fromEntries(searchParams);
    //         console.log(toFields)
    //         toFields.datetime = searchParams.getAll('datetime') || undefined;
    //         setValues(toFields, false);
    //     }
    // }, [searchParams]);

    // Aninhar em {params} mandava tudo para o servidor como um unico
    // "params=date%3D...%26time%3D...", entao nenhum filtro chegava a ser lido
    const filtrosAtivos = useMemo(() => {
        const obj = {};
        for (const [chave, valor] of searchParams.entries()) {
            if (obj[chave] === undefined) obj[chave] = valor;
            else obj[chave] = [].concat(obj[chave], valor);
        }
        return obj;
    }, [searchParams]);

    const {data, error, mutate, isLoading} = useFetch('/search', filtrosAtivos);
    useHandleErrors(error);
    const theme = useTheme();
    const mathcSm = useMediaQuery(theme.breakpoints.up('sm'));

    return (
        <>
            <Container maxWidth="lg" sx={{pt: 4}}>
                <Grid container columnSpacing={2} sx={{maxWidth: '100%'}}>
                    {mathcSm && (
                        <FilterForm
                            handleChange={handleChange}
                            setValues={setValues}
                            setFieldValue={setFieldValue}
                            errors={errors}
                            values={values}
                            handleSubmit={handleSubmit}
                            handleReset={handleReset}
                        />
                    )}
                    <Grid item xs={12} sm={12} md={9}>
                        <Grid container direction="row" alignItems="center" justifyContent="space-between">
                            <Stack direction="row" justifyContent="space-between">
                                {Boolean(user.profile) && (
                                    <Button onClick={e => navigation('/meus-encontros/novo')}>
                                        Criar meu encontro
                                    </Button>
                                )}
                                {!mathcSm && (
                                    <Button onClick={e => setOpenFilter(true)} variant="contained">
                                        Pesquisar
                                    </Button>
                                )}
                            </Stack>
                        </Grid>
                        <FeedSearch data={data} isLoading={isLoading} />
                    </Grid>
                </Grid>
            </Container>
            {!mathcSm && (
                <Dialog open={openFilter} onClose={e => setOpenFilter(false)}>
                    <DialogContent>
                        <FilterForm
                            handleChange={handleChange}
                            setValues={setValues}
                            setFieldValue={setFieldValue}
                            errors={errors}
                            values={values}
                            handleSubmit={handleSubmit}
                            handleReset={handleReset}
                        />
                    </DialogContent>
                </Dialog>
            )}
        </>
    );
};
